/**
 * SOLID Review
 * S — Strong. One concern: what the tab keeps — read, or nothing when the tab cannot be read.
 * O — Strong. A new kept record is the tab storage's.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. One read.
 * D — Strong. The tab storage port, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { IEntityClientStored } from '../../domain/ports/schemas/ClientSession';
import type { IPortClientTabStorage } from '../ports/contracts';

const NOTHING_STORED: IEntityClientStored = { guest: null, resume: null };

/** The tab's stored game and guest identity (FE2). Storage the tab cannot read holds nothing, as the storage helpers answered null on any error. */
export class StoredRecords {
  constructor(private readonly tabStorage: IPortClientTabStorage) {}

  async read(ctx: IContextRequest): Promise<IEntityClientStored> {
    const read = await this.tabStorage.stored(ctx);
    return read.success ? read.value : NOTHING_STORED;
  }
}
